import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { ExecutionResult } from 'graphql';
import { MutationResult } from '@apollo/react-common';
import {
  ConnectFitnessMutationVariables,
  ConnectFitnessMutation,
} from '../../../types/__generated__';
import { useCallback } from 'react';

export const CONNECT_FITNESS = gql`
  mutation connectFitness($input: ConnectFitnessInput!) {
    connectFitness(input: $input)
  }
`;

export default function useConnectFitness({
  code,
  scope,
}: any): [
  () => Promise<ExecutionResult<ConnectFitnessMutation>>,
  MutationResult<ConnectFitnessMutation>,
] {
  const [runMutation, mutationResult] = useMutation<
    ConnectFitnessMutation,
    ConnectFitnessMutationVariables
  >(CONNECT_FITNESS, {
    context: {
      credentials: 'include',
    },
  });

  return [
    useCallback(
      () =>
        runMutation({
          variables: {
            input: {
              code,
              scope,
            },
          },
        }),
      [runMutation, code, scope],
    ),
    mutationResult,
  ];
}
